/* eslint-disable */
export default function init(Blockly, profile) {
    Blockly.Arduino.time = {};
    Blockly.Arduino.time_delay = function() {
        return "delay(" + (Blockly.Arduino.valueToCode(this, "DELAY_TIME_MILI", Blockly.Arduino.ORDER_ATOMIC) || "0") + ");\n"
    };
    Blockly.Arduino.time_delay_seconds = function() {
        let delay = Blockly.Arduino.valueToCode(this, "DELAY_TIME_SECONDS", Blockly.Arduino.ORDER_ATOMIC) || "0"
        if (!isNaN(Number(delay))) {
            delay *= 1000;
        }
        return "delay(" + delay + ");\n"
    };
    Blockly.Arduino.time_delaymicros = function() {
        return "delayMicroseconds(" + (Blockly.Arduino.valueToCode(this, "DELAY_TIME_MICRO", Blockly.Arduino.ORDER_ATOMIC) || "0") + ");\n"
    };
    Blockly.Arduino.time_seconds = function() {
        return ["(millis()/1000)", Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.time_millis = function() {
        return ["millis()", Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.time_micros = function() {
        return ["micros()", Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.infinite_loop = function() {
        return "while(true);\n"
    };
    Blockly.Arduino.time_runeveryms = function() {
        var a = Blockly.Arduino.statementToCode(this, "DO"),
            b = Blockly.Arduino.valueToCode(this, "MS", Blockly.Arduino.ORDER_ATOMIC) || "0",
            c = Blockly.Arduino.nameDB_.getDistinctName("task_time_ms", Blockly.VARIABLE_CATEGORY_NAME);
        Blockly.Arduino.definitions_["var_" + c] = "unsigned long " + c + "=0;\n";
        a = "if((millis()-" + c + ")>=" + b + "){\n\t" + (c + "=millis();\n") + a;
        return a += "}\n"
    };
    Blockly.Arduino.time_runeverys = function() {
        let a = Blockly.Arduino.statementToCode(this, "DO")
        let b = Blockly.Arduino.valueToCode(this, "S", Blockly.Arduino.ORDER_ATOMIC) || "0"
        if (!isNaN(Number(b))) {
            b *= 1000;
        }
        let c = Blockly.Arduino.nameDB_.getDistinctName("task_time_ms", Blockly.VARIABLE_CATEGORY_NAME)
        Blockly.Arduino.definitions_["var_" + c] = "unsigned long " + c + "=0;\n";
        a = "if((millis()-" + c + ")>=" + b + "){\n\t" + (c + "=millis();\n") + a;
        return a += "}\n"
    };
    Blockly.Arduino.time_timer = function() {
        var a = this.getFieldValue("TYPE");
        Blockly.Arduino.definitions_.var_time_timer = "unsigned long time_timer=millis();\n";
        var b = "(millis()-time_timer)";
        "s" == a && (b = "((millis()-time_timer)/1000)");
        return [b, Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.time_timer_lite = function() {
        var a = this.getFieldValue("TYPE");
        Blockly.Arduino.definitions_.var_time_timer = "unsigned long time_timer=millis();\n";
        var b = "(millis()-time_timer)";
        "s" == a && (b = "((millis()-time_timer)/1000)");
        return [b, Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.time_timer_reset = function() {
        Blockly.Arduino.definitions_.var_time_timer = "unsigned long time_timer=millis();\n";
        return "time_timer=millis();\n"
    };
}